import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import FlagIcon from 'vue-flag-icon'
// import VueGtag from 'vue-gtag'
import i18n from './i18n'

Vue.config.productionTip = false
Vue.use(FlagIcon)
// Vue.use(VueGtag, {
//   config: { id: 'G-T43E3TLZGY' }
// })

new Vue({
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
